import { CompanySource } from '_types';

export const VALID_SOURCES: CompanySource[] = ['orbis', 'companyhouse', 'pipl'];

export const getValidSource = (source: string): CompanySource | undefined =>
  VALID_SOURCES.find((validSource) => validSource === source);
